export const navigateToDashboard = () =>
  window.open("https://my.proxyfidelity.com", "_blank");
